<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX18zin5ruFO1gNddeqEuovm+eqfaHY7fe24=","cpf":"U2FsdGVkX1+NO/HGaEbEiYDr+eZPbGNTCM9pfjpwe5M="},{"num_cand":"U2FsdGVkX1/Nfi5hzmCFUMekLByXyaDOVJo4rroRVwY=","cpf":"U2FsdGVkX18VH98otJ0pvGKmp+uxIhTmrr+nTc9xnAA="},{"num_cand":"U2FsdGVkX18+p1M2DnIDpWtupnkMvf7k5Tur26q6PRo=","cpf":"U2FsdGVkX1/A4wHTYzrQ8RyeYNVTTngZtKaB3p6KYMQ="},{"num_cand":"U2FsdGVkX19sLX8rLO7ACXWh2MX1KJZPSVxHGY5+U0s=","cpf":"U2FsdGVkX1/QYOSCSovmXGj7G3BHHgDk8H1FvFz/0AQ="},{"num_cand":"U2FsdGVkX189QTXWccGnIqE91lxyWxjBGcpZoHmy2m0=","cpf":"U2FsdGVkX1+Q+2Tk89M66sCqns7zRmBzwY16gvcRACo="},{"num_cand":"U2FsdGVkX1+yzgJfKCeKionYNiSYmUubjsdyLZLPuXQ=","cpf":"U2FsdGVkX18BSiq81Rp0f69yGb/KU4tmaBzEV3KmtJA="},{"num_cand":"U2FsdGVkX18jBUhNoHrJdSqiEurYv7N9xYZO6UJfQZ8=","cpf":"U2FsdGVkX18msbkjI5bFk0ftUYwuzw5Yt5CnEibxWwg="},{"num_cand":"U2FsdGVkX19Nc46eVv7pwcQaKkHu0+RfRE7yUcwVDdw=","cpf":"U2FsdGVkX18VjlAYK9PrU3KmVgQlNPXmQhMonLQ16XE="},{"num_cand":"U2FsdGVkX1+Ce0X/W+K/998qvzMbHShQHlko8OQCXbw=","cpf":"U2FsdGVkX19o61vID0/idwMYLwGvXaQ3L2hyrpamtSo="},{"num_cand":"U2FsdGVkX196X7nOmZSkT+Rt77A9rpgOy/Vlh1e7a54=","cpf":"U2FsdGVkX18PLnHDOW8AIziMagDY20GHVVnawcH1G3s="},{"num_cand":"U2FsdGVkX19cV9Eqppw0Uk0e4mZ58duJbBLvxWe/Pzg=","cpf":"U2FsdGVkX1+paiiZsevfPehVweqpzt4r/4PVTL17AYI="},{"num_cand":"U2FsdGVkX19ye2Da+hz1OPPF3dyrgSTsGGUfuN7c+Xc=","cpf":"U2FsdGVkX18GxmAGfOTibPdZMbUVLJ1gMbNkCzu8rO8="},{"num_cand":"U2FsdGVkX19lDhSXfQDtO3cMkeX6Cmubub7oFT5YOOA=","cpf":"U2FsdGVkX18lqoWSbdIpqyDx7uPhloHPiaDPU92ljKA="},{"num_cand":"U2FsdGVkX18MKytDk3q8YFOjcvlBTL5IyGGZ+qwRkvI=","cpf":"U2FsdGVkX183mNDQXhRmfdQUcmXO4FJdLAvWboc+SMk="},{"num_cand":"U2FsdGVkX18dQMyjHH1eNn1u6HQyfwgf4LizLP/5QW8=","cpf":"U2FsdGVkX1/9w+3LEI2R08llaN+G2c6BQ0yKEW9SjXE="},{"num_cand":"U2FsdGVkX1+kIzRDVW5Ivu+tQ0dvTU1NI9YWm3C08kc=","cpf":"U2FsdGVkX1/ju/u8J72w0CniLgxKIwEJwZKz5a3nH8c="},{"num_cand":"U2FsdGVkX19XEK2EWaFqD+3weAG32+UBtS8ei7XzT4g=","cpf":"U2FsdGVkX19xz2kuzPGAVvS8qiXhvW52kSGNfXpCG+k="},{"num_cand":"U2FsdGVkX19NhM5hRJKqpIoBfxnW+CYXUBuNrmnPgWQ=","cpf":"U2FsdGVkX1/X6hntE1NB6fROI0c/btUPCFXZ6smhZOg="},{"num_cand":"U2FsdGVkX18toNNg+a/Q9wIDROUJA2PCl3ra4A6QVq4=","cpf":"U2FsdGVkX19zwY+aS+Bn3xNYnoxdf5PSLc5FUsCZAGQ="},{"num_cand":"U2FsdGVkX18Vtdi8FXxXrALmz13qOrGaMJL5u/vK0n8=","cpf":"U2FsdGVkX1/Tssr5ku2Af6AGRIAYZQKW+40uRzr0Xz0="},{"num_cand":"U2FsdGVkX1/6Oidh9ogdnUpKlMuGjF4ubTLjKMSCWG8=","cpf":"U2FsdGVkX1+290jOazbV2+nZw38oHZYtg/m6TixMumU="},{"num_cand":"U2FsdGVkX18jxCl0cNfAODtZhpapwAG783mehYWqXd0=","cpf":"U2FsdGVkX1+0IiwcGgLLcYp+j6X6n3vZs3nzTp9NBYM="},{"num_cand":"U2FsdGVkX18RfbSUHQk2zAbxp/IdUZiDrQEcRntp9ZQ=","cpf":"U2FsdGVkX1/CzHLwYHaB7Jr7HC4OA4dQWQa4UFdC+Aw="},{"num_cand":"U2FsdGVkX189KHwnbdTL8KzPU/vA2PT+j4Ki1la8oEA=","cpf":"U2FsdGVkX18CDmzx5NWQ0rfC6XvJURH5OjbxJtt/S38="},{"num_cand":"U2FsdGVkX1/77u7hv8QMlXLSOXlZXdSEKiEvWWJb4qM=","cpf":"U2FsdGVkX18tKh1795jZ2/ifsLhEIzg0PHza3ySY3GE="},{"num_cand":"U2FsdGVkX18DC51j2XqUrjN+xJBO+JfHDkOlQDjaPzM=","cpf":"U2FsdGVkX1/9qfPruWRErAYX6hulR5LYs61dRDXaN84="},{"num_cand":"U2FsdGVkX1/lmJkg7aKnowa0oSCzCGSzCoHGzIqASkw=","cpf":"U2FsdGVkX19QmoI0s3gKMpgOJhA1FaO5Z1AxT3e4O0E="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2205/rec_laudo_pcd/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
